export const DEFAULT_BULK_SHORT_URL = 'https://wv3.io/########';
